import { Splide } from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

export function slide() {
  // Splide01の初期化
  if (document.querySelector(".splide01")) {
    new Splide(".splide01", {
      type: "loop",
      perPage: 3,
      perMove: 1,
      autoplay: true,
      interval: 3000,
      pauseOnHover: false,
      pagination: false,
      arrows: false,
      focus: 0,
      gap: "min(48px, calc(48 / 1440 * 100vw))",
      fixedWidth: "min(360px, calc(360 / 1440 * 100vw))",
    }).mount();
  }

  // Splide02の初期化
  if (document.querySelector(".splide02")) {
    new Splide(".splide02", {
      perPage: 3,
      type: "loop",
      focus: 0,
      autoScroll: {
        speed: 2,
      },
    }).mount({ AutoScroll });
  }

  // メインスライダーとサムネイルの同期
  if (document.querySelector(".splide-main") && document.querySelector(".thumbnail-carousel")) {
    document.addEventListener("DOMContentLoaded", function () {
      // メインスライダー
      const main = new Splide(".splide-main", {
        type: "fade",
        rewind: true,
        pagination: false,
        arrows: false,
      });
      
      // サムネイルスライダー
      const thumbnails = new Splide(".thumbnail-carousel", {
        type: "loop",
        perPage: 3,
        pagination: false,
        isNavigation: true,
        focus: "center",
        arrows: false,
        gap: "20px",
        // spサイズ時
        breakpoints: {
          768: {
            gap: "8px",
          },
        },
      });

      // 同期とマウント
      main.sync(thumbnails);
      main.mount();
      thumbnails.mount();
    });
  }
}
